module.exports = __webpack_public_path__ + "static/logo-abf2b639f8d7b2c8d78439564bae70f9.png";